
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24 0H0v16h24V0z","fill":"#D80027"}}),_c('path',{attrs:{"d":"M12 0H0v8h12V0z","fill":"#0052B4"}}),_c('path',{attrs:{"d":"M8.74 4l-1.12.527.596 1.084-1.215-.233-.154 1.228L6 5.703l-.846.903L5 5.378l-1.216.232.596-1.083L3.261 4l1.12-.526-.597-1.084L5 2.622l.154-1.228.846.903.847-.903L7 2.622l1.215-.232-.596 1.084L8.74 4z","fill":"#F0F0F0"}}),_c('path',{attrs:{"d":"M6 5.36a1.36 1.36 0 100-2.72 1.36 1.36 0 000 2.72z","fill":"#0052B4"}}),_c('path',{attrs:{"d":"M6 4.909a.91.91 0 010-1.818.91.91 0 010 1.818z","fill":"#F0F0F0"}})])
          )
        }
      }
    